import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalService } from 'src/app/shared/components/modal/modal.service';

@Component({
  selector: 'app-confirmed-modal',
  templateUrl: './confirmed-modal.component.html',
  styleUrls: ['./confirmed-modal.component.scss']
})
export class ConfirmedModalComponent implements OnInit {

  @Input() data: any;

  public confirmModalEvent$: Subject<boolean>;

  constructor(
    private modalService: ModalService
  ) { }

  ngOnInit() {
    this.confirmModalEvent$ = new Subject();
  }

  public onClose() {
    this.modalService.closeModal(false);
  }

  public onConfirm(): void {
    this.modalService.closeModal(true);
  }
}
